import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { MdbModalRef, MdbModalService, MdbRippleModule } from 'mdb5-adapted';
import {
  BasicEmployersSearchComponent,
} from 'src/app/features/branch-employers/basic-employer-form/basic-employer-form.component';

import { AddressModel, ClientShowModel, EmploymentDetailsModel } from '@lmsModels';
import { ClientDetailsService } from '@lmsrestServices';
import { LMS_NoSpecialsDirective, LmsModalFrameComponent, NumbersOnlyDirective } from '@lmsSharedUI';

import { AppUtilityService } from '../app-utility.service';
import { BranchEmployerService } from '../core/services/branch-employer.service';
import { EmploymentDialogComponent } from '../employment-dialog/employment-dialog.component';
import { EmployerDetailsModel } from '../features/branch-employers/models/employer-details-model';
import { UpdateEmployerComponent } from '../features/branch-employers/update-employer/update-employer.component';
import { ClientHeaderComponent } from '../modules/client-header/client-header.component';

@Component({
  selector: 'app-employment-details',
  templateUrl: './employment-details.component.html',
  styleUrls: ['./employment-details.component.scss'],
  standalone: true,
  imports: [CommonModule, MdbRippleModule, FormsModule, ReactiveFormsModule,
    NumbersOnlyDirective, LMS_NoSpecialsDirective, LmsModalFrameComponent, ClientHeaderComponent]
})

export class EmploymentDetailsComponent implements OnInit, AfterViewInit {
  @ViewChild(BasicEmployersSearchComponent) employerBasicSearchComponent: BasicEmployersSearchComponent;

  employmentDetailsModel = new EmploymentDetailsModel();
  employmentDetailsForm = this.formBuilder.group({
    employeeNumber: ['', [Validators.required]],
    department: [''],
    occupation: ['', [Validators.required]],
    placement: [''],
    lineManagerFirstName: ['', [Validators.required]],
    lineManagerLastName: ['', [Validators.required]],
    lineManagerEmail: [''],
    lineManagerContactNumber: ['', [Validators.required]],
    workAdressLine1: [''],
    workAdressLine2: [''],
    workAdressSuburb: [''],
    workAdressTown: [''],
    workAdressAreaCode: ['']
  });

  clientShowModel = {} as ClientShowModel;
  addressModel: AddressModel;
  employment: any;
  private _hasEmployment = false;
  private _partInfo = false;
  refreshEmployment = false;
  hasWorkaddress = false;
  // employmentDetails : any;
  submitted = false;
  //employmentOtpForm: FormGroup;
  //sendDisabled: boolean;
  confirmEmployment: boolean;
  addresses: any;
  mustConfirm: boolean;
  isValidDate: boolean;

  startDate = new Date(Date.now());
  endDate = new Date(Date.now());
  employStartDate = new Date(Date.now());
  employEndDate = new Date(Date.now());

  lstEmployers: any[] = [];
  foundEmployer: boolean;
  //employerNametxt = '';
  quoteEmployName: string;

  isReadOnly = false;
  employmentConfirmed = false;
  clientStatus: string;
  employer: any;

  constructor(
    private clientDetailsService: ClientDetailsService,
    private branchEmployerService: BranchEmployerService,
    private formBuilder: FormBuilder,
    public global_utility: AppUtilityService,
    private modalservice: MdbModalService,
    public modalRef: MdbModalRef<EmploymentDetailsComponent>) { }

  get hasEmployment() {
    return this._hasEmployment;
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.employment.employerName = this.quoteEmployName;

    setTimeout(() => {
      this.employmentDetailsForm.patchValue({
        employeeNumber: this.employmentDetailsModel.employeeNumber,
        department: this.employmentDetailsModel.department,
        occupation: this.employmentDetailsModel.occupation,
        placement: this.employmentDetailsModel.placement,
        lineManagerFirstName: this.employmentDetailsModel.lineManagerFirstName,
        lineManagerLastName: this.employmentDetailsModel.lineManagerLastName,
        lineManagerEmail: this.employmentDetailsModel.lineManagerEmail,
        lineManagerContactNumber: this.employmentDetailsModel.lineManagerContactNumber,
        workAdressLine1: this.employmentDetailsModel.workAdressLine1,
        workAdressLine2: this.employmentDetailsModel.workAdressLine2,
        workAdressSuburb: this.employmentDetailsModel.workAdressSuburb,
        workAdressTown: this.employmentDetailsModel.workAdressTown,
        workAdressAreaCode: this.employmentDetailsModel.workAdressAreaCode
      });
      this.clientStatus = this.clientShowModel.clientStatus!;

      this.validateEmployeeDetails();
      if (this.employmentDetailsModel.confirmed) {
        this.employmentConfirmed = true;
        this._hasEmployment = true;
      }
    });

    console.log("Employment details -----", this.employmentDetailsModel);
  }

  findEmployerByTNR(empTNR?: string) {
    const employersSearch = { employerTNR: empTNR || this.employment.employerTNR, branchSerial: this.employment.branchSerial };
    console.log(employersSearch, 'employer Search');
    return new Promise<boolean>((resolve, reject) => {
      this.branchEmployerService.findEmployerBySerialTNR(employersSearch)
        .subscribe({
          next: (employerList: any) => {
            //hasEmployment will enable the dropdown on Edit
            //this.hasEmployment = false;
            if (employerList && employerList?.id != 0) {
              this.branchEmployerService.setquoteEmployerObs(employerList);
              this.lstEmployers = employerList;
              this.employer = employerList;
              this.foundEmployer = (employerList && employerList.id > 0);
              // this.employmentDetailsModel = employerList;
              resolve(this.foundEmployer);
            }
            else {
              reject(new Error('Employer not found or invalid response.'));
            }
          },
          error: (err) => {
            reject(new Error(err));
          }
        });
    });
  }

  close() {
    this.modalRef.close();
    //return this.dialogRef.close(this.employmentDetailsForm.value);
  }

  saveEmployeeDetails() {
    this.submitted = true;
    if (this.employmentDetailsForm.invalid) {
      return;
    }

    this.mustConfirm = this.employmentDetailsForm.dirty && this.employmentDetailsForm.touched;
    this.confirmEmployment = !this.mustConfirm;

    if (this.employmentDetailsModel.employerName.toUpperCase() == 'SASSA') {
      this.employmentDetailsModel.confirmed = true;
      this.confirmEmployment = true;
      this.doSaveEmploymentDetails();
      return;
    }

    this.modalservice.open(EmploymentDialogComponent, {
      backdrop: true, ignoreBackdropClick: true, keyboard: true, nonInvasive: false, animation: true,
      modalClass: 'modal-md modal-top'
    }).onClose.subscribe(result => {
      if (result) {
       // this.confirmEmployment = result && result.empConfirmed;

      this.confirmEmployment = result.empConfirmed === true;

      if (this.confirmEmployment) {
        if (result.contactPersonName && result.contactPersonName.trim()) {
          this.employmentDetailsModel.contactPersonName = result.contactPersonName.trim();
          console.log('Contact person name captured:', this.employmentDetailsModel.contactPersonName);
        }

        if (result.contactNumber && result.contactNumber.trim()) {
          this.employmentDetailsModel.contactPersonNumber = result.contactNumber.trim();
          console.log('Contact number captured:', this.employmentDetailsModel.contactPersonNumber);
        }
      } else {
        this.employmentDetailsModel.contactPersonName = '';
        this.employmentDetailsModel.contactPersonNumber = '';
      }

      this.employmentDetailsModel.confirmed = this.confirmEmployment;
      this.employmentDetailsModel.confirmedByUser = this.global_utility.getGlobalData('userDisplay');

      console.log('Employment Details Model before save:', {
        confirmed: this.employmentDetailsModel.confirmed,
        contactPersonName: this.employmentDetailsModel.contactPersonName,
        contactPersonNumber: this.employmentDetailsModel.contactPersonNumber,
        confirmedByUser: this.employmentDetailsModel.confirmedByUser
      });

        this.doSaveEmploymentDetails();
      }
    });
  }

  private doSaveEmploymentDetails() {
  this.global_utility.startLoading('Saving employment');

  this.employmentDetailsModel.confirmed = this.confirmEmployment;
  this.employmentDetailsModel.confirmedByUser = this.global_utility.getGlobalData('userDisplay');

  this.employmentDetailsModel.userName = this.global_utility.getGlobalData('userDisplay');
  this.employmentDetailsModel.branchName = this.global_utility.getGlobalData('branch_Name');
  this.employmentDetailsModel.branch = this.global_utility.getGlobalData('branch_Name');
  this.employmentDetailsModel.clientNumber = Number(this.clientShowModel.clientNumber) || 0;
  this.employmentDetailsModel.employerName = this.employmentDetailsModel.employerName.toUpperCase();
  this.employmentDetailsModel.name = this.employmentDetailsModel.employerName.toUpperCase();

  if (this.confirmEmployment && this.employmentDetailsModel.contactPersonName) {
    console.log('Saving employment confirmation with contact:', {
      contactPerson: this.employmentDetailsModel.contactPersonName,
      contactNumber: this.employmentDetailsModel.contactPersonNumber
    });
  }

  setTimeout(() => {
    let savingemployment = true;
    this.clientDetailsService.saveEmploymentDetails(this.employmentDetailsModel).subscribe({
      next: (res: any) => {
        savingemployment = false;
        this.global_utility.stopLoading();
        if (res && res.id > 0) {
          res.quoteId = this.employmentDetailsModel.quoteId;
          this.employmentDetailsModel.workAdressLine1 = res.workAdressLine1;
          this.employmentDetailsModel.workAdressLine2 = res.workAdressLine2;
          this.employmentDetailsModel.workAdressSuburb = res.workAdressSuburb;
          this.employmentDetailsModel.workAdressTown = res.workAdressTown;
          this.employmentDetailsModel.workAdressAreaCode = res.workAdressAreaCode;

          if (this.confirmEmployment) {
            this.global_utility.success('Employment confirmed successfully!', 'Success');
          } else {
            this.global_utility.info('Employment details saved but NOT confirmed.', 'Information');
          }
        }

        if (!res) {
          this.global_utility.info('Employer information NOT saved!! Was employment confirmed?', 'Action required');
        }
        this.modalRef?.close(res);
      },
      error: (err) => {
        savingemployment = false;
        this.global_utility.stopLoading();
        //this.errorServiceHandler.handle(err);
      }
    });

    setTimeout(() => {
      if (savingemployment) {
        this.global_utility.info('Saving employer information is taking longer than expected, please wait.', 'Awaiting Response');
        this.global_utility.stopLoading();
      }
    }, 25000);
  }, 200);
}


  validateEmployeeDetails() {
    this.startDate.setDate(1);
    this.endDate.setMonth(this.endDate.getMonth() + 1);
    this.endDate.setDate(1);
    this.endDate.setDate(this.endDate.getDate() - 1);

    this.employStartDate.setFullYear(this.employStartDate.getFullYear() - 5);
    this.employEndDate.setMonth(this.employEndDate.getMonth() - 3);

    // if (!this.employment || (this.employment.employerName?.toUpperCase() != 'SASSA' && !this.employment.employeeNumber)) {
    //   this.foundEmployer = true
    this.global_utility.stopLoading();


    //If SASSA employer
    if (this.quoteEmployName === 'SASSA') {
      this.employmentDetailsModel.employerName = this.quoteEmployName;
      this.employmentDetailsForm.controls['employeeNumber'].disable();
      this.employmentDetailsForm.controls['department'].disable();
      this.employmentDetailsForm.controls['placement'].disable();
      this.employmentDetailsForm.controls['occupation'].disable();
      this.employmentDetailsForm.controls['employeeNumber'].clearValidators();
      this.employmentDetailsForm.controls['department'].clearValidators();
      this.employmentDetailsForm.controls['placement'].clearValidators();
      this.employmentDetailsForm.controls['occupation'].clearValidators();
    }

    if (this.quoteEmployName != 'SASSA' && this.employment.employeeNumber) {
      this.mustConfirm = false;
      this.confirmEmployment = true;

      if (!this.employment.confirmedBy) {
        this.confirmEmployment = false;
      }
    }
    this.hasWorkaddress = false;
    this.employmentDetailsModel.workAdressLine1 = this.employment.physicalAddress1;
    this.employmentDetailsModel.workAdressLine2 = this.employment.physicalAddress2;
    this.employmentDetailsModel.workAdressSuburb = this.employment.physicalSuburb;
    this.employmentDetailsModel.workAdressTown = this.employment.physicalTown;
    this.employmentDetailsModel.workAdressAreaCode = this.employment.physicalCode;

    for (const address of this.addresses) {
      if (address.addressType == 'WORK') {
        this.hasWorkaddress = true;
        this.employmentDetailsModel.workAdressLine1 = address.line1;
        this.employmentDetailsModel.workAdressLine2 = address.line2;
        this.employmentDetailsModel.workAdressSuburb = address.suburb;
        this.employmentDetailsModel.workAdressAreaCode = address.code;
        this.employmentDetailsModel.workAdressTown = address.town;
      }
    }

    // Else tis will be incorrect on employer fetch
    this.employmentDetailsModel.id = this.employment.id;
    this.employmentDetailsModel.quoteId = this.employment.quoteId;
    this.employmentDetailsModel.serial = this.employment.branchSerial;
    this.employmentDetailsModel.employerTNR = this.employment.employerTNR;
    this.employmentDetailsModel.employmentType = this.employment.employmentType;
    this.employmentDetailsModel.address = this.employment.address;
    this.employmentDetailsModel.employmentStartDate = this.employment.employmentStartDate;
    this.employmentDetailsModel.contractStartDate = this.employment.contractStartDate;
    this.employmentDetailsModel.contractEndDate = this.employment.contractEndDate;
    this.employmentDetailsModel.wageCalendar = this.employment.wageCalendar;
    this.employmentDetailsModel.shiftingRule = this.employment.shiftingRule;

    this.employmentDetailsModel.occupation = this.employment.occupation;
    this.employmentDetailsModel.employerName = this.employment.name?.toUpperCase();
    this.employmentDetailsModel.payDate = this.employment.payDate;
    this.employmentDetailsModel.paymentMethod = this.employment.paymentMethod;

    if (!this.isReadOnly) {
      if (this.employment.employerTNR && !this.employment.employeeNumber) {
        this._partInfo = true;
        this.onEmploymentSelect({ id: this.employment.id, tnumber: this.employment.employerTNR });
      } else {
        this._hasEmployment = this.employment.employeeNumber && this.employment.employerTNR;
        this.mapEmploymentToModel();
      }
    }
  }

  editEmploymentTNR() {
    if (this.employment) {
      this._hasEmployment = false;
      this.mustConfirm = false;
    }
  }

  cancelEdit() {
    this.validateEmployeeDetails();
    this._hasEmployment = true;
  }

  mapEmploymentToModel(onlypart = false) {
    //This will always be from employment and should be populated already (new or not)
    this.employmentDetailsModel.employerName = this.employment.name;
    //this.employerNametxt = this.employmentDetailsModel.employerName;
    this.employmentDetailsModel.parentCompany = this.employment.parentCompany;
    this.employmentDetailsModel.department = this.employment.department;
    this.employmentDetailsModel.occupation = this.employment.occupation;
    this.employmentDetailsModel.placement = this.employment.placement;


    if (onlypart) {
      this.employmentDetailsModel.wageCalendar ||= this.employment.luEmpPayFrequency;
      this.employmentDetailsModel.paymentMethod = this.employment.luSalaryMethodDesc;
      this.employmentDetailsModel.shiftingRule = this.employment.luPaydateShiftDesc;
      this.employmentDetailsModel.payDate = this.employment.payDate;
      this.employmentDetailsModel.employerTNR = this.employment.tnumber;

      if (!this.hasWorkaddress) {
        this.hasWorkaddress = true;
        this.employmentDetailsModel.workAdressLine1 = this.employment.physicalAddress1;
        this.employmentDetailsModel.workAdressLine2 = this.employment.physicalAddress2;
        this.employmentDetailsModel.workAdressSuburb = this.employment.physicalSuburb;
        this.employmentDetailsModel.workAdressTown = this.employment.physicalTown;
        this.employmentDetailsModel.workAdressAreaCode = this.employment.physicalCode;
      }
      return;
    }

    //_partInfo = true If employment details not yet captured or first time capture
    //We only want to populate if we have full details
    if (!this._partInfo) {
      this.employmentDetailsModel.employerTNR = this.employment.employerTNR;
      this.employmentDetailsModel.lineManagerFirstName ||= this.employmentDetailsModel.employerName == 'SASSA' ? 'sassa' : this.employment.lineManagerFirstName;
      this.employmentDetailsModel.lineManagerLastName ||= this.employmentDetailsModel.employerName == 'SASSA' ? 'sassa' : this.employment.lineManagerLastName;
      this.employmentDetailsModel.lineManagerEmail = this.employment.lineManagerEmail;
      this.employmentDetailsModel.lineManagerContactNumber = this.employment.lineManagerContactNumber;

      this.employmentDetailsModel.employeeNumber ||= this.employmentDetailsModel.employerName == 'SASSA' ? 'sassa' : this.employment.employeeNumber;
      this.employmentDetailsModel.paymentMethod = this.employment.paymentMethod;
      this.employmentDetailsModel.shiftingRule = this.employment.shiftingRule;
      this.employmentDetailsModel.payDate = this.employment.payDate;

      if (!this.hasWorkaddress && this.employment.address) {
        this.employmentDetailsModel.workAdressLine1 = this.employment.address.line1;
        this.employmentDetailsModel.workAdressLine2 = this.employment.address.line2;
        this.employmentDetailsModel.workAdressSuburb = this.employment.address.suburb;
        this.employmentDetailsModel.workAdressTown = this.employment.address.town;
        this.employmentDetailsModel.workAdressAreaCode = this.employment.address.code;
      }
      else {
        if (!this.hasWorkaddress) {
          this.hasWorkaddress = true;
          this.employmentDetailsModel.workAdressLine1 = this.employment.workAdressLine1;
          this.employmentDetailsModel.workAdressLine2 = this.employment.workAdressLine2;
          this.employmentDetailsModel.workAdressSuburb = this.employment.workAdressSuburb;
          this.employmentDetailsModel.workAdressTown = this.employment.workAdressTown;
          this.employmentDetailsModel.workAdressAreaCode = this.employment.workAdressAreaCode;
        }
      }
      this.employmentDetailsModel.confirmed ||= this.employment.confirmedBy != '';
      this.employmentDetailsModel.confirmedByUser ||= this.employment.confirmedBy;
    }
  }

  mapEmployerToFormForce(employer: any) {
    if (employer) {
      this.employmentDetailsModel.serial = employer.branchSerial || employer.serial;
      // this.employerNametxt = employer.name;
      this.employmentDetailsModel.employerName = employer.name;
      this.employmentDetailsModel.parentCompany = employer.parentCompany || this.employment.parentCompany;

      this.employmentDetailsModel.payDate = employer.payDate || this.employment.payDate;
      this.employmentDetailsModel.shiftingRule = employer.luPaydateShiftDesc;
      this.employmentDetailsModel.branch = employer.branch || employer.employerBranch;
      this.employmentDetailsModel.branchName = employer.branchName;
      this.employmentDetailsModel.company = employer.company;
      this.employmentDetailsModel.wageCalendar = employer.luEmpPayFrequency;
      this.employmentDetailsModel.paymentMethod = employer.luSalaryMethodDesc;
      this.employmentDetailsModel.workAdressLine1 = employer.physicalAddress1;
      this.employmentDetailsModel.workAdressLine2 = employer.physicalAddress2;
      this.employmentDetailsModel.workAdressSuburb = employer.physicalSuburb;
      this.employmentDetailsModel.workAdressTown = employer.physicalTown;
      this.employmentDetailsModel.workAdressAreaCode = employer.physicalCode;

      this.employmentDetailsModel.employerTNR = employer.tnumber ?? employer.employerTNR;
      this.employmentDetailsModel.lineManagerEmail = employer.email;
      this.employmentDetailsModel.lineManagerContactNumber = employer.tel1;
      this.employmentDetailsModel.occupation = employer.occupation;
    }
  }

  goforNew() {
    const newemployer = new EmployerDetailsModel();
    this.branchEmployerService.preppedforCreate = true;
    this.modalservice.open(UpdateEmployerComponent, {
      backdrop: true, ignoreBackdropClick: true, keyboard: true, nonInvasive: false, animation: true,
      modalClass: 'modal-xl modal-dialog-centered modal-dialog-scrollable d-flex d-flex-lg update-employer-modal',
      data: {
        employerDetailsModel: newemployer
      }
    }).onClose.subscribe((employer) => {
      if (employer) {
        this.employmentDetailsModel.wageCalendar = this.employmentDetailsModel.wageCalendar = this.employmentDetailsModel.payFrequency || '';
        this.employmentDetailsModel.employerName = this.employmentDetailsModel.employerName || this.branchEmployerService.employerDetailsModel.employerName;
        // this.employerNametxt = this.employmentDetailsModel.employerName;
        return true;
      }

      this.global_utility.warning('Employment details not saved', 'Incomplete employment');
      return false;
    });
  }

  ReloadEmployer() {
    // this.RefreshEmployer = true;
  }

  onEmploymentSelect(event: any) {
    let employerId = event.target?.value || 0;

    if (event && event.tnumber) {
      //const tnumber = event.tnumber;

      console.log("onEmploymentSelect");
      return;
    }

    // Below is possible depricated with above return
    if (!isNaN(event.id) && event.employerName) {
      employerId = event.id;

      return;
    }

    if (Array.isArray(this.lstEmployers)) {
      for (const employ of this.lstEmployers) {
        if (employerId == employ.id) {
          console.log(employ, "..employ");

          this.mapEmployerToFormForce(employ);
          break;
        }
      }
    }
  }


  isContactNumberLength() {}

  covertDate(date: any) {
    if (date != null) {
      let str = date;
      str = str.substring(0, 10);
      date = str;
      return date; // this.myDatepipe.transform(date, 'dd/MM/yyyy');
    } else {
      return date;
    }
  }


confirmEmploymentDetails() {
  this.employmentDetailsModel.isConfirmedEmploymentDetails = true;

  this.modalservice.open(EmploymentDialogComponent, {
    modalClass: 'modal-md modal-top',
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: true,
    nonInvasive: false,
    animation: true
  }).onClose.subscribe(result => {
    if (result) {
          //this.confirmEmployment = result && result.empConfirmed === true;

          this.confirmEmployment = result && result.empConfirmed === true;

          if (this.confirmEmployment) {
            if (result.contactPersonName && result.contactPersonName.trim()) {
              this.employmentDetailsModel.contactPersonName = result.contactPersonName.trim();
            }

            if (result.contactNumber && result.contactNumber.trim()) {
              this.employmentDetailsModel.contactPersonNumber = result.contactNumber.trim();
            }
          } else {
            this.employmentDetailsModel.contactPersonName = '';
            this.employmentDetailsModel.contactPersonNumber = '';
          }

          this.employmentDetailsModel.confirmed = this.confirmEmployment;
          this.employmentDetailsModel.confirmedByUser = this.global_utility.getGlobalData('userDisplay');

          this.doSaveEmploymentDetails();
        }
      });
    }

  removeSpaces(event: any): void {
    if (event.target.value) {
      event.target.value = event.target.value.replace(/\s/g, '');
    }
  }

 preventDigitsAndSpecialChars(event: KeyboardEvent): void {
  const charCode = event.which ? event.which : event.keyCode;
  if ((charCode < 65 || charCode > 90) &&
      (charCode < 97 || charCode > 122) &&
      charCode !== 32) {
    event.preventDefault();
  }
}

preventDigitsAndSpecialCharsOnInput(event: any): void {
  if (event.target.value) {
    event.target.value = event.target.value.replace(/[^a-zA-Z\s]/g, '');
  }
}

}


